import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="border-y border-gold/50 bg-industrial py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-20" data-mp="1yeb4ckorj8qr">
      <div className="mx-auto max-w-4xl px-4" data-id="element-21" data-mp="1anxlnks2im8u">
        <SectionHeading id="bonus-title" data-id="element-22" data-mp="1aop6c0k4mzkc">The {totalBonuses} <span className="text-gold" data-id="element-23" data-mp="15pw2z0yk0oxw">Exclusive Bonuses</span></SectionHeading>

        <ul className="mt-10 overflow-hidden rounded-2xl border border-electric/50 bg-navy shadow-glow" data-id="element-24" data-mp="1jgr3npywfzqe">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.li key={bonus.title} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.28,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex gap-4 border-b border-electric/20 p-5 last:border-b-0 sm:p-6" data-id="element-25" data-mp="1eo7r8wby7an6" data-mpi={index}>
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-gold text-navy shadow-glow-gold" data-id="element-26" data-mp="2jhcvqxr1pe0v">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-27" data-mp="2ogg0eh345i8b" />
                </span>
                <div data-id="element-28" data-mp="1qua7cyg32joc">
                  <p className="font-display text-sm font-extrabold uppercase tracking-[.14em] text-gold" data-id="element-29" data-mp="1qv1vjo7cpf4l">Bonus {bonus.number}</p>
                  <h3 className="mt-1 font-display text-xl font-bold leading-tight text-silver" data-id="element-30" data-mp="20remiebihevn">{bonus.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-steel" data-id="element-31" data-mp="25q7yu3f2azu8">{bonus.description}</p>
                </div>
              </motion.li>;
        })}
        </ul>

        <div className="mt-6 flex flex-col items-center justify-between gap-5 rounded-2xl border-2 border-gold bg-navy px-6 py-6 text-center shadow-glow-gold sm:flex-row sm:text-left" data-id="element-32" data-mp="3c8o40vb2xwub">
          <div data-id="element-33" data-mp="1h1kf649q34ye">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-steel" data-id="element-34" data-mp="1h589h5mzrve6">Value of all {totalBonuses} bonuses</p>
            <p className="mt-1 font-display text-4xl font-bold tracking-tight text-steel line-through decoration-electric decoration-2" data-id="element-35" data-mp="1q3tpat12wwb9">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-36" data-mp="ycnu8r07tosu">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-steel" data-id="element-37" data-mp="ydp4it9eq79i">Your price today</p>
            <p className="mt-2 inline-flex items-center gap-2 rounded-xl bg-gold px-4 py-1.5 font-display text-4xl font-extrabold tracking-tight text-navy" data-id="element-38" data-mp="tfdx0p6l48ug">
              <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-39" data-mp="12dzcucko99rj" /> FREE
            </p>
          </div>
        </div>
      </div>
    </section>;
}